import styled from "styled-components";
import { Modal, NewSelect } from "@bca/ui-library";

export const StyledModal = styled(Modal)`
  width: ${(props) => (props.isMobile ? "20.938rem" : "40.625rem")};
  height: 16.75rem;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.div`
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 1.25rem;
  text-align: left;
  margin-bottom: 1rem;
`;

export const StyledNewSelect = styled(NewSelect)`
  display: flex;
  flex: auto;
  min-width: ${(props) => (props.isMobile ? "19.688rem" : "28.125rem")};
  margin-top: 0;
`;
